import React from "react";

const PaginationControls = ({
  currentPage,
  totalPages,
  totalResults,
  onPageChange,
}) => {
  const lastPage = Math.max(totalPages, 1);

  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between mt-4 gap-3">
      <span className="fs-14 text-secondary">{totalResults} total</span>
      <ul className="pagination mb-0">
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <a
            href="##"
            className="page-link shadow-none"
            onClick={() => onPageChange(currentPage - 1)}
          >
            Previous
          </a>
        </li>
        <li className="page-item disabled">
          <span className="page-link shadow-none">
            Page {currentPage} of {lastPage}
          </span>
        </li>
        <li
          className={`page-item ${currentPage >= lastPage ? "disabled" : ""}`}
        >
          <a
            href="##"
            className="page-link shadow-none"
            onClick={() => onPageChange(currentPage + 1)}
          >
            Next
          </a>
        </li>
      </ul>
    </div>
  );
};

export default PaginationControls;
